import Icon from ".";
import type { Slot } from "./Icon.types";
import type { MaterialNames } from "../material_symbol_names";
import classNames from "classnames";

export type SlotIconName = JSX.Element | MaterialNames;

const getIconName = (name: SlotIconName, size?: number, weight?: 300 | 400 | 800) =>
  typeof name === "object" ? name : <Icon name={name} size={size} weight={weight ?? 400} />;

export const SlotIcon = ({
  name,
  slot,
  disabled,
  className,
  size,
  weight,
  slotWrapperClassName
}: {
  name: SlotIconName;
  slot: Slot;
  disabled?: boolean;
  className?: string;
  size?: number;
  weight?: 300 | 400 | 800;
  slotWrapperClassName?: string;
}) => (
  <div
    slot={slot}
    className={classNames(
      slotWrapperClassName ?? "contents",
      {
        "[&>md-icon]:opacity-[0.38] [&>md-icon]:text-sys-brand-on-surface": disabled
      },
      className
    )}
  >
    {getIconName(name, size, weight)}
  </div>
);

export const SlotIconButton = ({ name, slot }: { name: SlotIconName; slot: Slot }) => (
  <div slot={slot} className="contents">
    {getIconName(name)}
  </div>
);
